const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z",
    fill: "#ECFAE6",
    style: {
      fill: "#ECFAE6",
      fill: "color(display-p3 0.9255 0.9804 0.9020)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 19.6654C13.9998 19.2972 14.278 18.9987 14.6212 18.9987H19.5918C19.935 18.9987 20.2132 19.2972 20.2132 19.6654C20.2132 20.0336 19.935 20.332 19.5918 20.332H14.6212C14.278 20.332 13.9998 20.0336 13.9998 19.6654Z",
    fill: "#319300",
    style: {
      fill: "#319300",
      fill: "color(display-p3 0.1922 0.5765 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8435 11.3966L19.7274 10.5132C20.3783 9.86233 20.3783 8.807 19.7274 8.15612C19.0766 7.50525 18.0213 7.50525 17.3704 8.15612L16.4865 9.03962L18.8435 11.3966Z",
    fill: "#319300",
    style: {
      fill: "#319300",
      fill: "color(display-p3 0.1922 0.5765 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5435 9.9822L9.56838 15.9544C9.03505 16.4877 8.73394 16.7888 8.49957 17.137C8.29171 17.4459 8.12451 17.7803 8.00213 18.1319C7.83373 18.6158 7.76668 19.1385 7.70571 19.6139C7.69062 19.7315 7.67588 19.8464 7.66009 19.957C7.64447 20.0663 7.68405 20.1763 7.76577 20.2507C7.84749 20.325 7.96074 20.354 8.06814 20.3282C8.20648 20.2948 8.35149 20.2629 8.50049 20.2301C8.98295 20.1238 9.50735 20.0083 9.98335 19.8065C10.2757 19.6825 10.5535 19.5268 10.8118 19.3421C11.1029 19.134 11.3581 18.8788 11.81 18.4268L17.9005 12.3392L15.5435 9.9822Z",
    fill: "#319300",
    style: {
      fill: "#319300",
      fill: "color(display-p3 0.1922 0.5765 0.0000)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.7d89b62a4ce89d794b02cd00990ba3c2.svg";
export { ForwardRef as ReactComponent };